import { render, staticRenderFns } from "./autoReplyConfig.vue?vue&type=template&id=82ae30f6&scoped=true"
import script from "./autoReplyConfig.vue?vue&type=script&lang=js"
export * from "./autoReplyConfig.vue?vue&type=script&lang=js"
import style0 from "./autoReplyConfig.vue?vue&type=style&index=0&id=82ae30f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ae30f6",
  null
  
)

export default component.exports